<template>
    <div class="custom-bread-crumb">
        <Breadcrumb>
            <BreadcrumbItem v-for="item in list" :to="item.to" :key="`bread-crumb-${item.name}`">
                <Icon v-if="showIcon" :type="item.icon" style="margin-right: 4px;"/>
                {{ $t(item.name).routerName }}
            </BreadcrumbItem>
        </Breadcrumb>
    </div>
</template>
<script>
export default {
    name: 'customBreadCrumb',
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        showIcon: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="less" scoped>
.custom-bread-crumb {
    display: inline-block;
    vertical-align: top;
}
</style>
